/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';

/**
 * Trigger a network request to login using an username and password pair.
 *
 * @type   {Function}
 * @param  {String}   username
 * @param  {String}   password
 * @return {Object}
 */
export const authRequestLogin = createAction(
    'auth/login-request',
    (username, password) => ({username, password})
);

/**
 * Add the received data to the store.
 *
 * @type   {Function}
 * @param  {Object}   userData
 * @return {Object}
 */
export const authReceiveLogin = createAction(
    'auth/login-receive',
    (userData) => ({userData})
);

/**
 * Trigger a network request to login using an username and password pair.
 *
 * @type   {Function}
 * @param  {String}   email
 * @return {Object}
 */
export const authRequestForgotPassword = createAction(
    'auth/forgot-password-request',
    (email) => ({email})
);

/**
 * Logout the current user.
 *
 * @type   {Function}
 * @return {Object}
 */
export const authLogout = createAction('auth/logout');

/**
 * Check logogin the current user.
 *
 * @type   {Function}
 * @return {Object}
 */
export const authCheckLogin = createAction('auth/checkLogin');
export const authCheckLoginReceived = createAction('auth/checkLoginReceived');
export const authGetUserDetail = createAction('auth/getUserDetail');
export const getConfig = createAction('auth/getConfig');
export const setConfig = createAction('auth/setConfig', (config) => ({config}));
export const unsetConfig = createAction('auth/unsetConfig');



// WEBPACK FOOTER //
// ./src/store/auth/actions.js